// onboarding APIs
export const GET_PODS = "serviceNow/get_pod_names";
export const GET_ROLES = "serviceNow/get_roles";
export const ADD_USER_TO_POD = "serviceNow/add_user_to_pod";
export const POD_ONBOARDING = "serviceNow/add_pod";
export const GET_REQUESTS = "serviceNow/get_request_by_user";
export const GET_REQUESTS_PAGINATED = "serviceNow/get_requests_paginated";
export const GET_REQUEST_DETAILS = "serviceNow/track_request";
export const ADD_USER_TO_AZURE_GROUP = "azure/add-user-to-group";
export const SAGEMAKER_ADD_USER = "sagemaker/sagemaker-add-user";

export const GET_INSTANCE_TYPES = "instanceConfig/get-instance-settings/dev";
export const VALIDATE_EMAIL = "serviceNow/validate-email";
export const SEARCH_DOCS = "fetch-confluence/search";
export const SEND_INQUIRY_EMAIL = "serviceNow/send-inquiry-email";

export const GET_CLOUD_SERVICES = "self-cloud-provisioning/forms";
export const GET_CLOUD_SERVICE_FORM = (serviceName: string) => `self-cloud-provisioning/forms/${serviceName}.json`;
export const SUBMIT_CLOUD_SERVICE_REQUEST = "self-cloud-provisioning/raise-request";
export const WANDB_ONBOARDING_STATUS_UPDATE_REQUEST = "wandb-provisioning/update-status";

// Team Directory APIs
export const GET_TEAM_DIRECTORY_CONFIG = "team-directory/config";

// Unity Catalog APIs
export const UNITY_CATALOG_PODS = "unity-catalog/pods";
export const UNITY_CATALOG_MODELS = "unity-catalog/models";

// Pipeline Metrics APIs
export const PIPELINE_METRICS_FILTERS = "pipeline-metrics/filters";
export const PIPELINE_METRICS_SUMMARY = "pipeline-metrics/summary";
export const PIPELINE_METRICS_METRICS = "pipeline-metrics/metrics";

// Pipelines APIs
export const PIPELINES_FILTERS = "pipelines/filters";
export const PIPELINES_SUMMARY = "pipelines/summary";
export const PIPELINES_CHARTS = "pipelines/charts";

// Jobs APIs
export const JOBS_FILTERS = "jobs/filters";
export const JOBS_SUMMARY = "jobs/summary";
export const JOBS_CHARTS = "jobs/charts";

// Users APIs
export const USERS_FILTERS = "users/filters";
export const USERS_SUMMARY = "users/summary";
export const USERS_CHARTS = "users/charts";

// Recently Viewed APIs (Home page widget)
export const RECENTLY_VIEWED = (userEmail: string) => `recently-viewed/${encodeURIComponent(userEmail)}`;

